import React from 'react';
import {
    Box,
    Select,
    MenuItem,
    Typography,
    IconButton
} from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function StandalonePagination({ page, rowsPerPage, count, onPageChange, onRowsPerPageChange }) {
    const totalPages = Math.ceil(count / rowsPerPage);
    const isFirstPage = page === 0;
    const isLastPage = page >= totalPages - 1;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 10,
                px: 5,
                py: 1.5,
                backgroundColor: '#f2f4f6',
                borderRadius: "10px"
            }}
        >
            <Typography variant="body2" sx={{ mr: 1 }}>
                Rows per page
            </Typography>
            <Select
                value={rowsPerPage}
                onChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
                size="small"
                sx={{
                    mr: 2,
                    minWidth: 64,
                    backgroundColor: '#fff',
                    height: 32,
                    fontSize: "14px",
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#000', // black border when focused
                    },
                }}
            >
                {[10, 25, 50, 100].map((value) => (
                    <MenuItem key={value} value={value}>
                        {value}
                    </MenuItem>
                ))}
            </Select>
            <Typography variant="body2" sx={{ mr: 2 }}>
                {page * rowsPerPage + 1}–{Math.min((page + 1) * rowsPerPage, count)} of {count}
            </Typography>

            <IconButton onClick={() => onPageChange(0)} disabled={isFirstPage}>
                <FirstPageIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => onPageChange(page - 1)} disabled={isFirstPage}>
                <KeyboardArrowLeftIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => onPageChange(page + 1)} disabled={isLastPage}>
                <KeyboardArrowRightIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => onPageChange(totalPages - 1)} disabled={isLastPage}>
                <LastPageIcon fontSize="small" />
            </IconButton>
        </Box>
    );
}
